import { Components, ComponentsProps } from "@thisgorilla/primate-ds";
import {
  Dispatch,
  Fragment,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";
import { useTheme } from "styled-components";

import { API_CALLS } from "../../../../../API/api_calls";
import { useDropdownKeyDown } from "../../../../../hooks/useDropdownKeyDown";
import { useAppSelector } from "../../../../../redux";
import { FlexColumn } from "../../../../Common/Styles";
import UserInfo from "../../../../Common/UserInfo";
import {
  AccountManageContainer,
  ButtonContainer,
  DropdownWrapper,
  UserContainer,
  Wrapper,
} from "./style";

const Menu = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const { typography } = useTheme();
  const containerRef = useRef<HTMLDivElement>(null);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const { profile_picture, id, headline, first_name, last_name } =
    useAppSelector((state) => state.me);

  const options = [
    {
      title: "Account",
      option: [
        {
          label: "Settings & Privacy",
          onClick: () => {},
          key: 0,
          iconType: "none",
        },
        {
          label: "Help & Support",
          onClick: () => {},
          key: 1,
          iconType: "none",
        },
        {
          label: "Language",
          onClick: () => {},
          key: 2,
          iconType: "none",
        },
      ],
    },
    {
      title: "Manage",
      option: [
        {
          label: "My Posts and Activity",
          onClick: () => {},
          key: 3,
          iconType: "none",
        },
      ],
    },
    {
      title: "",
      option: [
        {
          label: "Give Feedback",
          onClick: () => {},
          iconType: "MessageCircle",
          key: 4,
        },
        {
          label: "Switch Account",
          onClick: () => {},
          iconType: "Repeat",
          key: 5,
        },
        {
          label: "Log out",
          onClick: () => {
            API_CALLS.AUTH.logout();
          },
          iconType: "LogOut",
          key: 6,
        },
      ],
    },
  ];

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.focus();
    }
  }, []);

  const onKeyDown = useDropdownKeyDown({
    handleSelect: (option) => {
      option.onClick();
    },
    highlightedIndex,
    setHighlightedIndex,
    isDropdownOpen: isOpen,
    options: options.flatMap(({ option }) => option),
    setDropdownOpen: setIsOpen,
  });

  return (
    <DropdownWrapper
      $gapInPx={8}
      tabIndex={-1}
      onKeyDown={onKeyDown}
      ref={containerRef}
    >
      <UserContainer>
        <UserInfo
          id={id}
          headline={headline}
          name={first_name + " " + last_name}
          profile_picture={profile_picture}
          avatarSize="Small-40"
          showUserInfoOnHover={false}
        />
        <ButtonContainer>
          <Components.Button
            color="Primary"
            disabled={false}
            kind="Secondary"
            label="View Profile"
            onClick={() => {}}
            size="XS"
          />
        </ButtonContainer>
      </UserContainer>
      <Components.ListItem type="Divider" />
      <AccountManageContainer $gapInPx={8}>
        {options.slice(0, 2).map(({ option, title }, index) => (
          <Fragment key={index}>
            <Wrapper $gapInPx={7}>
              <Components.Text
                text={title}
                style={{ tokenStyle: typography.Heading.XS }}
                lineHeight="line-height-75"
                fontWeight="font-weight-semibold"
              />
              <FlexColumn $gapInPx={0}>
                {option.map(({ label, onClick, key }) => (
                  <Components.ListItem
                    type="List Item"
                    label={label}
                    onClick={onClick}
                    key={key}
                    onHover={() => setHighlightedIndex(key)}
                    isHighlighted={highlightedIndex === key}
                  />
                ))}
              </FlexColumn>
            </Wrapper>
            {!index && <Components.ListItem type="Divider" />}
          </Fragment>
        ))}
      </AccountManageContainer>
      {options[2].option.map(({ label, onClick, key, iconType }, index) => (
        <Fragment key={key}>
          {index < options[2].option.length - 1 && (
            <Components.ListItem type="Divider" />
          )}
          <Components.ListItem
            type="List Item"
            label={label}
            iconType={
              iconType as ComponentsProps.ListItemProps.ListItemCommon["iconType"]
            }
            onClick={onClick}
            onHover={() => setHighlightedIndex(key)}
            isHighlighted={highlightedIndex === key}
          />
        </Fragment>
      ))}
    </DropdownWrapper>
  );
};

export default Menu;
